import { dynamic } from '#/utils/dynamic';

export const DynamicSearchGroupsRefinements = dynamic(
  () =>
    import('./SearchGroupsRefinements').then((m) => ({
      default: m.SearchGroupsRefinements,
    })),
  { strategy: 'client-only' },
);
